import { Component, Input, OnInit } from '@angular/core'
import { NavigationService } from '@spartacus/storefront'
import {
  User,
  CmsService,
  AuthService,
  GlobalMessageService,
  GlobalMessageType,
  LanguageService,
} from '@spartacus/core'
import { Router } from '@angular/router'
import { Observable, of } from 'rxjs'
import { switchMap } from 'rxjs/operators'
import { ChangeDetectorRef } from '@angular/core'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { LANGUAGES } from '../../models/languages.model'
import { CommonService } from '../../shared/services/common.service'

@Component({
  standalone: false,
  // tslint:disable-next-line:component-selector
  selector: 'vs-nav-bar-links',
  templateUrl: './nav-bar-links.component.html',
  styleUrls: ['./nav-bar-links.component.scss'],
})
export class NavBarLinksComponent implements OnInit {
  linkright$ = this.cmsService.getComponentData('VsRequestQuoteNavComponent')
  linkleft$ = this.cmsService.getComponentData('VsCategoryNavComponent')
  requestQuote$ = this.service.getNavigationNode(this.linkright$)
  catogory$ = this.service.getNavigationNode(this.linkleft$)

  isShowDivIf = false
  link: any
  linkURL: any
  rightNavData: any
  currentLanguage: any
  itemsArr: any[]
  @Input() userType

  constructor(
    private cmsService: CmsService,
    private auth: AuthService,

    private service: NavigationService,
    private router: Router,
    protected languageService: LanguageService,
    private commonService: CommonService,
    private globalMessageService: GlobalMessageService,
    private changeDetection: ChangeDetectorRef,
    private userAccountFacade: UserAccountFacade
  ) {}

  user$: Observable<User>
  nodeData: any
  isUserLoggedInFlag: boolean

  navigateService() {
    this.router.navigate(['quote/service'])
  }

  navigateProducts() {
    this.isShowDivIf = !this.isShowDivIf
    this.commonService.closeMenu.next({
      profileMenu: false,
      miniCart: false,
      megaNavMenu: this.isShowDivIf,
      changeAccMenu: false,
    })
  }

  ngOnInit(): void {
    this.itemsArr = []
    for (const key in LANGUAGES) {
      this.itemsArr.push({
        label: LANGUAGES[key],
        value: key,
      })
    }
    this.getDefaultLanguage()
    this.commonService.closeMenu.subscribe((menuStatus) => {
      this.isShowDivIf = menuStatus.megaNavMenu
      this.changeDetection.detectChanges()
    })
    this.requestQuote$.subscribe((success: any) => {
      this.rightNavData = []
      success.children.forEach((navNode) => {
        if (navNode?.url) {
          this.rightNavData.push(navNode)
        }
        this.changeDetection.detectChanges()
      })
      // this.rightNavData = success;
    })
    this.commonService.getMessage.subscribe(
      (massage) => {
        if (massage === 'closeMegaMenu') {
          this.isShowDivIf = false
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
    this.commonService.getMenuActive().subscribe(
      (data: any) => {
        this.isShowDivIf = data.activeMenu
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )

    this.user$ = this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        this.isUserLoggedInFlag = isUserLoggedIn
        if (isUserLoggedIn) {
          return this.userAccountFacade.get()
        } else {
          return of(undefined)
        }
      })
    )
  }
  getDefaultLanguage() {
    this.languageService.getActive().subscribe((res) => {
      this.currentLanguage = LANGUAGES[res]
    })
  }
  onLanguageChange(event) {
    this.languageService.setActive(event)
    this.refreshCurrentRoute()
  }

  closeMenu() {
    this.isShowDivIf = false
  }

  goToBulkOrder() {
    this.router.navigate(['/bulk-Order'])
  }

  navigateWelcomePackage() {
    this.router.navigate(['/welcome-package/serial-search'])
  }
  refreshCurrentRoute() {
    const currentRoute = this.router.url
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigateByUrl(currentRoute)
    })
  }
}
